// pages/Dashboard/Settings.js
function Settings() {
  return <h2>Settings</h2>;
}

export default Settings;